import { render, staticRenderFns } from "./MateriForm.vue?vue&type=template&id=2e2239ae"
import script from "./MateriForm.vue?vue&type=script&lang=js"
export * from "./MateriForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports